import React, { useState, useEffect, useRef } from "react";
import { useConversation } from "@11labs/react";
import '../HaroldPopup.css';
import CloseIcon from '../imgs/close-circle.png';
import MicroIcon from '../imgs/microphone.png';
import BackIcon from '../imgs/arrow-circle-left.png';



const HaroldPage = () => {
  const [conversationStarted, setConversationStarted] = useState(false);
  const [conversationTime, setConversationTime] = useState(0);
  const timerRef = useRef(null);

  const { startSession, endSession, status, isSpeaking } = useConversation({
    onConnect: () => console.log("✅ Connesso"),
    onDisconnect: () => console.log("❌ Disconnesso"),
    onMessage: (msg) => console.log("📩 Messaggio:", msg),
    onError: (err) => console.error("Errore:", err),
  });

  const startConversation = async () => {
    setConversationStarted(true);
    setConversationTime(0);

    try {
      await startSession({ agentId: "LJGmqv8qUugaiKiK3aQu" });
      timerRef.current = setInterval(
        () => setConversationTime((prev) => prev + 1),
        1000
      );
    } catch (err) {
      console.error("Errore avvio conversazione", err);
    }
  };

  const stopConversation = async () => {
    try {
      await endSession();
      setConversationStarted(false);
      clearInterval(timerRef.current);
    } catch (err) {
      console.error("Errore fine conversazione", err);
    }
  };

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };

  return (
    <div className="harold-container">
      <div className="video-wrapper">
        <video autoPlay loop muted playsInline>
          <source
            src="https://www.deepagent.app/wp-content/uploads/2025/03/HAROLD.mp4"
            type="video/mp4"
          />
        </video>
      </div>
      <div className="controls">
        <button className="home-button"  onClick={() => window.location.href = "https://www.salespark.it/"}><img src={BackIcon} alt="Chiudi conversazione" /></button>
        <button className="start-button" onClick={startConversation}>Inizia una conversazione</button>
        <button className="stop-button" onClick={stopConversation}><img src={CloseIcon} alt="Chiudi conversazione" /></button>
      </div>
      {conversationStarted && (
        <div className="timer">{formatTime(conversationTime)}</div>
      )}
    </div>
  );
};

export default HaroldPage;
